import React from 'react'
import type { LotteryRound } from '../../services/lotteryService'
import { getWinningNumbers, hasAnyResult, displayValue, getDrawLabelNgod } from './resultDisplayUtils'
import LotteryResultSectionHeader from './LotteryResultSectionHeader'

type Props = {
  sectionTitle: string
  rounds: LotteryRound[]
  onRoundClick?: (round: LotteryRound) => void
}

/** Section: หวยธกส., หวยออมสิน, etc. - 3ตัวบน, 2ตัวล่าง. Uses bgg-6. */
const LotteryResultSectionSimple: React.FC<Props> = ({
  rounds,
  onRoundClick,
}) => {
  return (
    <>
      {rounds.map((round) => {
        const wn = getWinningNumbers(round)
        const hasResult = hasAnyResult(round)
        const isCancelled = round.status === 'cancelled'
        const disp = (v: string) => displayValue(v, { isCancelled, hasResult })
        const drawLabel = getDrawLabelNgod(round)
        const isClickable = !!onRoundClick
        return (
          <div key={round._id} className="col-12 col-lg-6 px-1 mb-4">
            <LotteryResultSectionHeader
              title={round.huayName}
              iconUrl={round.huayTypeIcon}
              drawLabel={drawLabel}
            />
            <div
              className="wrap-box p-2 pt-0 bgg-6 bdr-5"
              style={isClickable ? { cursor: 'pointer' } : undefined}
              onClick={() => onRoundClick?.(round)}
              onKeyDown={(e) => e.key === 'Enter' && onRoundClick?.(round)}
              role={isClickable ? 'button' : undefined}
              tabIndex={isClickable ? 0 : undefined}
            >
              <div className="row mx--1">
                <div className="col-12 col-lg-6 px--1 mt-2 animateMe" data-animation="fadeInUp">
                  <div className="t-medium c-white text-center">
                    <small>3ตัวบน</small>
                  </div>
                  <div className="bg-white bdr-5 bx-sd p-1 text-center">
                    <div className="px-1">
                      <h5>{disp(wn.threeUp)}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6 px--1 mt-2 animateMe" data-animation="fadeInUp">
                  <div className="t-medium c-white text-center">
                    <small>2ตัวล่าง</small>
                  </div>
                  <div className="bg-white bdr-5 bx-sd p-1 text-center">
                    <div className="px-1">
                      <h5>{disp(wn.twoDown)}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default LotteryResultSectionSimple
